import styled from "styled-components";

export const Container=styled.div`
overflow:auto;
position:relative;
`;
